<div class="collection-container" *ngIf="visible">
  <div class="collection-bg" [class.landscape]="isLandscapeLayout" *ngIf="vm.backgroundImageUrl; else fallback">
    <div class="image-blur"></div>
    <img class="" osnSharedUseAsPicture [src]="vm.backgroundImageUrl" [imgQuery]="imgQuery" [alt]="vm.title" />
  </div>
  <ng-template #fallback>
    <div
      class="placeholder-layer"
      [class.placeholder-layer-portrait]="!isLandscapeLayout"
      [style.background-image]="
        isLandscapeLayout
          ? 'url(assets/images/placeholder/collectionLandscape.png)'
          : 'url(assets/images/placeholder/collectionPortrait.png)'
      "
    ></div>
  </ng-template>
  <div class="carousel-wrapper" [ngClass]="isLandscapeLayout ? 'carousel-wrapper--landscape' : 'carousel-wrapper--portrait'">
    <osn-shared-carousel-title
      *ngIf="!hasTitleTreatment; else titleTreatmentImgTemp"
      class="container-fluid d-flex carousel-spacing"
      [title]="vm.titleToDisplay"
      [attr.aria-label]="vm.localizedTitles.en"
      [link]="routerLink"
      [canNavigateOnTitleClick]="!!vm.collectionPageSlug"
    ></osn-shared-carousel-title>
    <ng-template #titleTreatmentImgTemp>
      <div class="container-fluid d-flex justify-content-center">
        <a *ngIf="!!vm.collectionPageSlug; else simpleTitleTreatment" [routerLink]="routerLink">
          <img class="title" [src]="vm.titleTreatmentUrl" alt="Collection logo" />
        </a>
        <ng-template #simpleTitleTreatment>
          <img class="title" [src]="vm.titleTreatmentUrl" alt="Collection logo" />
        </ng-template>
      </div>
    </ng-template>
    <osn-shared-carousel
      [vm]="carouselViewModel"
      [showSeoTitle]="showSeoTitle"
      [carouselTitle]="vm.localizedTitles.en"
      (carouselItemSelect)="onCarouselItemSelect($event)"
      (carouselItemImpression)="onCarouselItemImpression($event)"
    ></osn-shared-carousel>
  </div>
</div>
